<div class="form-field has-suffix" [class.has-error]="showError">
  <label *ngIf="label">{{ label }}</label>
  <div
    class="input-wrapper"
    *ngIf="suffixIcon && (type === 'text' || type === 'password' || type === 'datepicker')"
  >
    <ng-container *ngIf="type === 'text' || type === 'password'">
      <input
        *ngIf="type === 'text' || type === 'password'"
        [type]="type"
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="onChange($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [disabled]="isDisabled"
      />
      <span class="suffix-icon" *ngIf="suffixIcon" (click)="suffixIconClick.emit()">
        <ui-svg-icon [svgIcon]="suffixIcon" size="large"></ui-svg-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="type === 'datepicker'">
      <input
        matInput
        [placeholder]="placeholder"
        [value]="value"
        (dateChange)="onDateChange($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [disabled]="isDisabled"
        readonly="true"
        [matDatepicker]="picker"
        [min]="minDate"
        (click)="picker.open()"
        class="datepicket-input"
      />
      <span class="clear-datepicker" *ngIf="value" (click)="clearDatePicker($event)">
        <ui-svg-icon svgIcon="close-cc" size="large"></ui-svg-icon>
      </span>
      <span class="suffix-icon" (click)="picker.open()">
        <ui-svg-icon svgIcon="calendar" size="large"></ui-svg-icon>
      </span>
      <mat-datepicker #picker></mat-datepicker>
    </ng-container>
  </div>
  <ng-container *ngIf="!suffixIcon">
    <input
      *ngIf="type === 'text' || type === 'password'"
      [type]="type"
      [placeholder]="placeholder"
      [ngModel]="value"
      (ngModelChange)="onChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [disabled]="isDisabled"
    />
    <textarea
      *ngIf="type === 'textarea'"
      [placeholder]="placeholder"
      [ngModel]="value"
      (ngModelChange)="onChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [disabled]="isDisabled"
      autocomplete="off"
      rows="4"
    ></textarea>
    <select
      *ngIf="type === 'select'"
      [ngModel]="value"
      (ngModelChange)="onChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [disabled]="isDisabled"
    >
      <option *ngFor="let option of options" [ngValue]="option.value">
        {{ option.label | translate }}
      </option>
    </select>
  </ng-container>

  <div class="error" *ngIf="showError">
    <small *ngFor="let error of errors">{{ error }}</small>
  </div>
</div>
